// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Fqdo","name":"Header_name__fvdLf","birthday":"Header_birthday__1ZLPf","skeleton":"Header_skeleton__1pABY"};